import {
  fetchPageview,
  fetchPageviewForCsv,
  fetchPrebidRevenue,
  fetchPrebidRevenueForCsv,
  fetchPublisherRevenue,
  fetchPublisherRevenueForCsv,
  fetchVideoPerformance,
  fetchVideoPerformanceForCsv,
} from '../../state/thunks/revenue_beta';
import { convertFilters } from '../../utils/params';
import {
  AVG_CPM,
  AVG_RPM,
  IMPRESSION_PER_PAGEVIEW,
  INITIAL_VIEWABILITY,
  PAGEVIEW_TYPE,
  PAGE_VIEWS,
  PRODUCT_TYPE,
  REFRESH_VIEWABILITY,
  VIDEO_COMPLETION_RATE,
  VIEWABILITY,
} from './monetization/consts';

/**
 * helper function used by both fetching data on beta monetization page and for exporting data in csv
 * @param {*} params , used to pass as payload to apis
 * @param {*} isLimitRequired , by default true which signfies limit will be used to limit records in response, isLimitRequired false signfies all data will be fetched from the api
 * @returns
 */
export function callRelevantApi(params, isLimitRequired = true) {
  if (
    params.filters.hasOwnProperty(PRODUCT_TYPE) &&
    params.filters[PRODUCT_TYPE] &&
    params.filters[PRODUCT_TYPE].includes('PREBID_ADAPTER')
  ) {
    return isLimitRequired ? fetchPrebidRevenue(params) : fetchPrebidRevenueForCsv(params);
  } else if (
    params.metrics.includes(AVG_RPM) ||
    params.metrics.includes(IMPRESSION_PER_PAGEVIEW) ||
    params.metrics.includes(PAGE_VIEWS)
  ) {
    if (params.metrics.includes(IMPRESSION_PER_PAGEVIEW)) delete params.filters[PRODUCT_TYPE];
    return isLimitRequired ? fetchPageview(params) : fetchPageviewForCsv(params);
  } else if (params.metrics.includes(VIDEO_COMPLETION_RATE)) {
    delete params.dimension;
    return isLimitRequired ? fetchVideoPerformance(params) : fetchVideoPerformanceForCsv(params);
  } else {
    if (params.metrics.includes(AVG_CPM) && params.filters.hasOwnProperty(PAGEVIEW_TYPE))
      params.filters = convertFilters(PRODUCT_TYPE, params.filters[PAGEVIEW_TYPE][0], params.filters);
    return isLimitRequired ? fetchPublisherRevenue(params) : fetchPublisherRevenueForCsv(params);
  }
}

/**
 * depending on the metric decides if its a percentage metric or not, used to limit y axis on graphs
 */
export function isPercentageMetric(metric) {
  if (metric === INITIAL_VIEWABILITY || metric === REFRESH_VIEWABILITY || metric === VIEWABILITY) return true;
  else return false;
}
